import React from 'react';

const SideNavList = ({ children, innerRef }) => (
  <ul ref={innerRef} className="side-nav-list-section__list">
    {children}
  </ul>
);

export default React.forwardRef((props, ref) => <SideNavList innerRef={ref} {...props} />);
